import WithRender from "../../templates/layouts/layoutPacking.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getAddToCartFullPage", "getPersonalizationFullPage"])
  }
});
